export default __webpack_public_path__ + "static/no-profile-pic-0f7d9ec458f5e45e551dc344226ef281.png";